import { useQuery } from "@tanstack/react-query";
import {
  IHistory,
  IHistoryData,
  historyDataToHistory,
} from "../domains/pslHistory.domain";
import PromoItemsService from "./promoItems.service";

const getPslHistory = (pslId: string | number) => async () =>
  PromoItemsService.fetchPSLHistory({ pslId }).then((res) =>
    historyDataToHistory(res)
  );

const getMaterialHistory = (materialId: string | number) => async () =>
  PromoItemsService.fetchMaterialHistory({ materialId }).then((res) =>
    historyDataToHistory(res)
  );

// export function usePslHistory(
//   pslId?: string | number,
//   materialId?: string | number,
//   otherOptions?: any
// ) {
//   return useQuery<IHistory[]>({
//     queryKey: ["pslHistory" + pslId + materialId],

//     queryFn: async () => {
//       if (Number(pslId) === 5560) {
//         console.log("========== 5560 TEST ==========");
//         console.log("PSL ID:", pslId);

//         console.log(
//           "vendorHistory count:",
//           response5560.vendorHistory?.length
//         );

//         console.log(
//           "materialHistory count:",
//           response5560.materialHistory?.length
//         );

//         try {
//           const history = historyDataToHistory(
//             response5560 as unknown as IHistoryData
//           );

//           console.log("Generated history count:", history.length);
//           console.table(history);

//           return history;
//         } catch (error) {
//           console.error("5560 HISTORY ERROR:", error);
//           throw error;
//         }
//       }

//       if (materialId) {
//         return getMaterialHistory(materialId)();
//       }

//       return getPslHistory(pslId)();
//     },

//     initialData: [],
//     ...(otherOptions || {}),
//   });
// }
export function usePslHistory(
  pslId?: string | number,
  materialId?: string | number,
  otherOptions?: any
) {
  return useQuery<IHistory[]>({
    queryKey: ["pslHistory" + pslId + materialId],
    queryFn: materialId
      ? getMaterialHistory(materialId)
      : getPslHistory(pslId),
    initialData: [],
    ...(otherOptions || {}),
  });
}